import * as Sentry from '@sentry/react';
import { SentryFallback } from '../components/UI/SentryFallback/SentryFallback';

export default function SentryBoundaryFallback({
  error,
  componentStack,
  eventId,
  resetError,
}) {
  const ensuredId = eventId ?? Sentry.captureException(error);
  return (
    <SentryFallback
      error={error}
      componentStack={componentStack}
      eventId={ensuredId}
      onRetry={resetError}
    />
  );
}
